// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="january-31-2019">January 31, 2019</h3>
      <p>Add Power of Attorney verification for future Appeals Version 1 <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2717">#2717</a></p>
      <hr />
      <h3 id="january-14-2019">January 14, 2019</h3>
      <p>Bug discovered and fixed for safe null requests <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2727">#2727</a></p>
      <hr />
      <h3 id="june-11-2018">June 11, 2018</h3>
      <p>Implement VA-required headers to retrieve status <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2024">#2024</a></p>
      <hr />
      <h3 id="may-23-2018">May 23, 2018</h3>
      <p>Add appeals service API <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/1961">#1961</a></p>
    </div>
  );
};

export default MarkdownComponent;
